module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/pierata.c642679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/pierata.jpg
// module id = n3hN
// module chunks = 0